import { render, staticRenderFns } from "./ClassifyTagManagement.vue?vue&type=template&id=6ea0cbda"
import script from "./ClassifyTagManagement.vue?vue&type=script&lang=js"
export * from "./ClassifyTagManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports